// Owner: page-editor. Titles of the page editor's keyboard commands. `commands.ts` loads with the app
// shell (discovered by glob) and stays tiny and free of message keys, so the catalog can be deferred
// later (plan §12); the editor fills these titles in when its module loads (`setPageEditorCommandTitles`),
// before its scope is active and the commands can show in the `?` sheet or ⌘K.
export type PageEditorCommandTitle =
  | 'scope'
  | 'groupBlocks'
  | 'groupText'
  | 'duplicate'
  | 'moveUp'
  | 'moveDown'
  | 'link'
  | 'paragraph'
  | 'h1'
  | 'h2'
  | 'h3'
  | 'orderedList'
  | 'bulletList'
  | 'taskList'
  | 'bold'
  | 'italic'
  | 'underline'
  | 'strike'
  | 'code';

const titles = new Map<PageEditorCommandTitle, string>();

export function setPageEditorCommandTitles(next: Record<PageEditorCommandTitle, string>): void {
  for (const [id, title] of Object.entries(next) as Array<[PageEditorCommandTitle, string]>)
    titles.set(id, title);
}

export const pageEditorCommandTitle = (id: PageEditorCommandTitle): string => titles.get(id) ?? id;
